import { Paper, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { mdiAccountGroup, mdiAccountStar } from '@mdi/js';
import Icon from '@mdi/react';
import classNames from 'classnames';
import React from 'react';

/* */
const mdIcons = {
  group: mdiAccountGroup,
  individual: mdiAccountStar,
};

/* */
const styles = (theme) => ({
  container: {
    padding: 16,
    marginRight: 16,
    minWidth: 100,
    cursor: 'pointer',
  },
  name: {
    marginTop: 8,
    userSelect: 'none',
    color: theme.palette.secondary.dark,
  },
  mdIcon: {
    color: theme.palette.secondary.dark,
  },
  activeContainer: {
    backgroundColor: theme.palette.secondary.dark,
  },
  activeName: {
    marginTop: 8,
    userSelect: 'none',
    color: theme.palette.common.white,
  },
  activeMdIcon: {
    color: theme.palette.common.white,
  },
});

/* */
const ActivityButton = withStyles(styles)(({ name, active, mdIcon, onClick, classes }) => (
  <Paper
    elevation={2}
    onClick={onClick}
    className={classNames(classes.container, {
      [classes.activeContainer]: active,
    })}
  >
    <Box display='flex' alignItems='center' flexDirection='column'>
      <Icon
        path={mdIcons[mdIcon] || mdiAccountGroup}
        size={1.2}
        className={classNames(classes.mdIcon, {
          [classes.activeMdIcon]: active,
        })}
      />
      <Typography
        component='span'
        className={classNames({
          [classes.name]: !active,
          [classes.activeName]: active,
        })}
      >
        {name}
      </Typography>
    </Box>
  </Paper>
));

/* */
const AcademySelector = ({ data, value, onChange }) => {
  if (Object.keys(data).length === 0) return null;

  return (
    <Box mb={3} display='flex' flexDirection='row'>
      <ActivityButton name='Cours Collectif' active={value === 0} onClick={() => onChange(0)} />
      {Object.keys(data).map((id) => (
        <ActivityButton
          key={id}
          name={data[id].name}
          mdIcon={data[id].mdIcon}
          active={value === Number(id + 1)}
          onClick={() => onChange(Number(id + 1))}
        />
      ))}
    </Box>
  );
};

export default AcademySelector;
